import { NgModule } from '@angular/core';

// Directives
import { MaxValidatorDirective } from './max-validator-directive';
import { MinValidatorDirective } from './min-validator-directive';

const directives = [MaxValidatorDirective, MinValidatorDirective];

@NgModule({
  declarations: [...directives],
  imports: [],
  exports: [...directives],
})
export class DirectivesModule {}
